module.exports = __webpack_public_path__ + "img/gbwhatsapp512.c65d635d.webp";